const allowedToUpdateKeys = ['__RequestVerificationToken'];

/**
 * 
 * @param {{
 * successContent: string
 * }} data
 * 
 * 
*/
export const ResendCodeButton = (data) => ({
    successContent: data.successContent,
    isDisabled: false,
    initialContent: '',
    formaction: '',
    init() {
        this.initialContent = this.$el.innerHTML;
        this.formaction = this.$el.formAction;
        this.$watch('isDisabled', () => {
            if (this.isDisabled) {
                this.$el.setAttribute('disabled', 'disabled');
            } else {
                this.$el.removeAttribute('disabled');
            }
        })
    },
    /**
     * 
     * @param {Event} event 
     */
    async onResendCodeClick(event) {
        event.preventDefault();

        if (this.formaction === '') {
            console.error('Form action is empty for resend code button');
            return false;
        }

        this.formref = this.$el.closest('form');
        if (!this.formref) {
            console.error('Form not found for resend code button');
            return false;
        }

        const callback = async () => {
            this.isDisabled = true;

            const verificationToken = document.getElementsByName('__RequestVerificationToken')[0].value;
            if (!verificationToken) {
                console.error('Verification token not found');
                this.isDisabled = false;
                return false;
            }

            const formData = new FormData(this.formref);

            const response = await fetch(this.formaction, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'RequestVerificationToken': verificationToken
                },
                body: new URLSearchParams(formData)
            });

            const responseBody = await response.text();
            try {
                const domParser = new DOMParser();
                const newHtml = domParser.parseFromString(responseBody, "text/html");
                const existingValidationMessage = document.getElementById("validationSummary");
                const newValidationMessage = newHtml.getElementById("validationSummary");
                const flowForm = newHtml.getElementById('flow-form');
                const newFormData = new FormData(flowForm);

                newFormData.forEach((value, key) => {
                    if (allowedToUpdateKeys.includes(key)) {
                        try {
                            const element = document.getElementById(key);
                            if (element) {
                                element.value = value
                            }
                        } catch (err) {
                            console.warn(`Failed to set new form data for ${key}`, err);
                        }
                    }
                });

                if (newValidationMessage && existingValidationMessage) {
                    existingValidationMessage.innerHTML = newValidationMessage.innerHTML;
                    if (newValidationMessage.innerHTML.trim() !== "") {
                        this.isDisabled = false;
                        return false;
                    }
                }

                const reCaptchaError = newHtml.getElementById('recaptcha-error');
                if (reCaptchaError) {
                    window.displayReCaptchaError(this.formref, reCaptchaError.innerHTML);
                    this.isDisabled = false;
                    return false;
                }

                this.$el.innerText = this.successContent;
                const resendIntervalInSecs = this.$el.getAttribute('data-resend-interval') ?? 30;

                setTimeout(() => {
                    this.$el.innerHTML = this.initialContent;
                    this.isDisabled = false;
                }, 1000 * resendIntervalInSecs);
            }
            catch (err) {
                this.isDisabled = false;
                console.error(err);
            }
        }

        if (window.RECAPTCHA_ENABLED && 
            this.formref.querySelector('input[name="g-recaptcha-response"]') && 
            typeof window.requestReCaptchaToken === 'function') {
            window.requestReCaptchaToken(this.formref, callback);
        } else {
            await callback();
        }
    }
})